export default{
    generateStationsMarkersGroup(station_prefixes){
        let textByType = (type)=>{
            return {
                text: (type == 2) ? "P" : "F"
            }
        }
        let markerByType = (type)=>{
            return {
                icon: (type == 2) ? 'tint' : 'water',
                backgroundColor: (type == 2) ? '#00ABDC' : '#188b16',
                borderWidth: 2
            }
        }
        let markerClick = (station_prefix_id) => {
            CURRENT_STATION_PREFIX = station_prefix_id
            $('#station_prefix_modal').modal('show');
        }
        let markers = L.markerClusterGroup();
        let options = {
            borderColor: 'white',
            textColor: 'white',
            innerIconStyle: 'margin-top:0;'
        };
        $.each(station_prefixes, function(index, station_prefix){
            let type = station_prefix.station_type.id
            let marker = L.marker(
                [station_prefix.station.latitude, station_prefix.station.longitude],
                {
                    icon: L.BeautifyIcon.icon({...options, ...markerByType(type), ...textByType(type)}),
                    prefix_id: station_prefix.id,
                    title: station_prefix.prefix,
                    prefix: station_prefix.prefix,
                    name_id: station_prefix.station.id,
                    name: station_prefix.station.name.substring(0, 30),
                    station_type_id: station_prefix.station_type.id,
                    station_type: station_prefix.station_type.name,
                    city: station_prefix.station.city.name,
                    city_id: station_prefix.station.city.id,
                    ugrhi: station_prefix.station.ugrhi.name,
                    ugrhi_id: station_prefix.station.ugrhi.id,
                    station_owner: station_prefix.station_owner.name,
                    station_owner_id: station_prefix.station_owner.id,
                }
            )
            marker.on('click', function(){
                markerClick(station_prefix.id)
            })
            markers.addLayer(marker);
        })
        return markers
    },
    getJSONLayer(url, feature_style){
        return new Promise((resolve, reject)=>{
            $.getJSON(url, function(data, status, xhr) {
                let featureGroup = L.featureGroup().addLayer(L.geoJson(data, {
                  onEachFeature: function (feature, layer) {
                    layer.setStyle(feature_style);
                  }
                }))
                resolve(featureGroup)
            })
        })
    },
    markersToCluster(markers){
        let cluster_markers = L.markerClusterGroup();
        $.each(markers, function(index, marker){
            cluster_markers.addLayer(marker);
        })
        return cluster_markers
    },
    featureStyles:{
        state(){
            return {color: "#545454",fillColor: "#8998fa", fillOpacity:0.1, weight: 1.5}
        }
    },
    generateLocationMarker(lat, lng, title){
        let options = {
            borderColor: 'red',
            iconShape: 'circle-dot',
            iconSize: [18,18],
            borderWidth: 5
        };
        return L.marker(
            [lat, lng],
            {
                icon: L.BeautifyIcon.icon(options)
            }
        ).bindPopup(title);
    }
}